import lodash from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import {Link} from 'react-router-dom';

import {statesRoute} from '../../routePaths';

import './stateHeader.scss';

/**
 * The StateHeader component.
 */
export class StateHeader extends React.Component {
  /**
   * @constructor
   * @param {{}} props
   * @param {{}} componentContext
   */
  constructor(props, componentContext) {
    super(props, componentContext);
  }

  /**
   * Renders the component.
   *
   * @returns {{}}
   */
  render() {
    /* if we have resource data, then we want to use the operating state location as the state title. If not, we'll just use the state data as the state title*/

    const isLoading = this.props.isLoading || false;
    const stateName = (this.props.stateData) ? this.props.stateData.name : null;
    const operatingStateLocation = this.props.resourceData ? this.props.resourceData.operatingState.name : stateName;
    let title = 'Loading...';
    if (!isLoading && operatingStateLocation) {
      title = lodash.upperFirst(operatingStateLocation);
    } else if (!isLoading) {
      title = 'Unknown State';
    }

    return (
      <div id="state-header" className="row">
        <div className="col state-header-col">
          <div className="row">
            <div className="col">
              <h1 className="main-title nei-h">{title}</h1>
            </div>
            <div className="col-12 col-sm-6">
              <h2 className="h4 change-state nei-h float-right">
                <Link to={statesRoute}>
                  Change State <i className="fa fa-chevron-down" />
                </Link>
              </h2>
            </div>
          </div>
          <div className="top-divide">
            <hr className="top-hr" />
            <hr className="top-hr" />
          </div>
        </div>
      </div>
    );
  }
}

StateHeader.propTypes = {
  isLoading: PropTypes.bool,
  stateData: PropTypes.shape({
    name: PropTypes.string,
  }),
};

StateHeader.defaultProps = {
  isLoading: false,
};

export default StateHeader;



// WEBPACK FOOTER //
// ./src/components/common/stateHeader/StateHeader.js